<template>
  <AppContainer :is-loading justify-center>
    <EHeroContent
      icon="building-user"
      :title="t(useTranslationPath(callerPath, 'title'), { site: siteName })"
      :description="t(useTranslationPath(callerPath, 'description'))"
    />

    <PrivacyPolicy />

    <template #bottom>
      <EButton :label="t(useTranslationPath(callerPath, 'next'))" block @click="onSubmit" />
    </template>
  </AppContainer>
</template>

<script setup>
import AppContainer from '@/components/AppContainer.vue'
import PrivacyPolicy from '@/components/PrivacyPolicy.vue'
import { useTranslationPath } from '@/composables/useTranslationPath.js'
import { useAppStore } from '@/stores/AppStore.js'
import { useUnauthenticatedTokenStore } from '@/stores/unauthenticated/UnauthenticatedTokenStore.js'
import { EButton, EHeroContent } from '@expansivefm/eds'
import { computed, onMounted, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'

const { t } = useI18n()
const callerPath = 'views.unauthenticated.welcome'
const unauthenticatedTokenStore = useUnauthenticatedTokenStore()
const router = useRouter()

const appStore = useAppStore()

const isLoading = ref(false)

const siteName = computed(
  () => unauthenticatedTokenStore.engineerCheckInAccessToken?.maintainable_entity_name,
)

onMounted(() => {
  appStore.$patch({ showBackButton: false })
})

const onSubmit = async () => {
  isLoading.value = true

  await router.push({
    name: 'auth.contractor',
  })
}
</script>
